<template lang="pug">
v-btn(
      text
      color="primary"
      :disabled="!filtersActive"
      @click="clearFilters"
      ) clear filter(s)
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState("search", [
      'filterString',
    ]),
    filtersActive() {
      return !!this.filterString;
    }
  },
  methods: {
    clearFilters() {
      this.$store.dispatch('search/clearFilters');
    },
  },
};
</script>
<style scoped>

</style>